import React, {Component} from 'react';
import { connect } from 'react-redux';
import Title from '../base/title';
import Cta from '../base/cta';
import api from '../../utils/api';

class StrategyPump extends Component {

  constructor(props) {
    super(props);
    this.state = {
      opened: true,
      loader: ' loader-box',
      strategy: {},
      readonly: true
    }
    this.save = this.save.bind(this);
    this.inherit = this.inherit.bind(this);
  }

  componentDidMount() {
    let _self = this;
    let _strategy = {};
    let readonly = true;
    api.get('product_strategies/?type=station&id=' + this.props.data.id).then(resp => {
      resp.data.forEach(strategy => {
        if (strategy.type === 'STATION') readonly = false;
        if (!_strategy[strategy.product.short_name]) _strategy[strategy.product.short_name] = { 
          COUNTRY: { value: '', product: '', id: '' }, 
          CLUSTER: { value: '', product: '', id: '' },
          STATION: { value: '', product: '', id: '' }
        };
        _strategy[strategy.product.short_name][strategy.type] = { value: strategy.difference, product: strategy.product.id, id: strategy.id };
      });
      Object.keys(_strategy).forEach(key => {
        if (_strategy[key].CLUSTER.id === '' && _strategy[key]['COUNTRY']) {
          _strategy[key].CLUSTER.value = _strategy[key].COUNTRY.value;
          _strategy[key].CLUSTER.product = _strategy[key].COUNTRY.product;
        }
        if (_strategy[key].STATION.id === '' && _strategy[key]['CLUSTER']) {
          _strategy[key].STATION.value = _strategy[key].CLUSTER.value;
          _strategy[key].STATION.product = _strategy[key].CLUSTER.product;
        }
      });
      _self.setState({ strategy: _strategy, readonly: readonly, loader: '' });
    });
  }

  inherit() {
    let _self = this;
    let promises = [];
    let _strategy = JSON.parse(JSON.stringify(this.state.strategy));
    Object.keys(_strategy).forEach(key => {
      if (_strategy[key].STATION.id !== '') {
        promises.push(new Promise((a, r) => {
          api.delete('product_strategies/id/' + _strategy[key].STATION.id).then(resp => {
            _strategy[key].STATION.id = '';
            _strategy[key].STATION.value = _strategy[key].CLUSTER.value;
            a(resp.data);
          });
        }));
      }
    });
    Promise.all(promises).then(data => {
      _self.setState({ 
        strategy: _strategy,
        readonly: true
      })
    });
  }

  save() {
    if (window.confirm('Realmente desea editar la estrategia?')) {
      let _self = this;
      let promises = [];
      let _strategy = JSON.parse(JSON.stringify(this.state.strategy));
      Object.keys(_strategy).forEach(key => {
        if (_strategy[key].STATION.id === '') {
          promises.push(new Promise((a, r) => {
            api.post('product_strategies', {
              service_station: _self.props.data.id,
              product: _strategy[key].STATION.product,
              difference: _strategy[key].STATION.value
            }).then(resp => {
              _strategy[key].STATION.id = resp.data.id;
              a(resp.data);
            });
          }));
        } else {
          promises.push(new Promise((a, r) => {
            api.put('product_strategies/id/' + _strategy[key].STATION.id, {
              difference: _strategy[key].STATION.value
            }).then(resp => {
              a(resp.data);
            });
          }));
        }
      });
      Promise.all(promises).then(data => {
        _self.setState({ strategy: _strategy })
      });
    }
  }

  render() {
    let _self = this;
    let _user = _self.props.user;
    return <div className="row">
        <Title isOpen={_self.state.opened} toggle={() => { _self.setState({ strategy: {}, opened: !_self.state.opened }, function() { if (_self.state.opened) _self.componentDidMount(); }); }} edit={ {onClick: () => { _self.setState({ readonly: false }); }, icon: 'fas fa-pencil-alt', label: 'EDITAR ESTRATEGIA'} } text="ESTRATEGIA" isGray={true} hasIcon={true} />
        {_self.state.opened && <div className="row">
          <div className="col s12">
            <div className="row">
              <div className={"marketShare" + this.state.loader}>
                <table className='c-table strategy'>
                  <thead className="no-border">
                    <tr>
                      <td className="border-bottom">&nbsp;</td>
                      {Object.keys(_self.state.strategy).map((key) =>
                        <td className="border-bottom center" key={key}>{key}</td>
                      )}
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="bordeable">
                      <td>Diferencial País (%)</td>
                      {Object.keys(_self.state.strategy).map((key) =>
                        <td key={key}><input readOnly="readonly" type="number" value={_self.state.strategy[key].COUNTRY.value}  /></td>
                      )}
                      <td></td>
                    </tr>
                    <tr className="bordeable">
                      <td>Diferencial Cluster (%)</td>
                      {Object.keys(_self.state.strategy).map((key) =>
                        <td key={key}><input readOnly="readonly" type="number" value={_self.state.strategy[key].CLUSTER.value} /></td>
                      )}
                      <td></td>
                    </tr>
                    <tr>
                      <td>Diferencial Estación (%)</td>
                      {Object.keys(_self.state.strategy).map((key) =>
                        <td key={key}><input readOnly={_self.state.readonly || !_user.canDefineStrategy} type="number" value={_self.state.strategy[key].STATION.value} onChange={ ev => { _self.state.strategy[key].STATION.value = ev.target.value;_self.setState(_self.state) }} /></td>
                      )}
                      {_user.canDefineStrategy ?
                      <td>
                        <div className="c-switch">
                          <span onClick={this.inherit} className={'c-switch-label'}>Heredado</span>
                          <div onClick={() => { _self.state.readonly ? _self.setState({ readonly: false }) : _self.inherit(); }} className="c-switch-toggler"><i className={_self.state.readonly ? '' : 'active'}></i></div>
                          <span onClick={() => { _self.setState({ readonly: false }); }} className={'c-switch-label ' + (_self.state.readonly ? '' : 'active')}>Manual</span>
                        </div>
                      </td> : <td></td>}
                    </tr>
                    {_user.canDefineStrategy ? !_self.state.readonly &&
                      <tr>
                        <td colSpan="6" className="centered">
                          <Cta text="CANCELAR" light centered className="medium mr-3" click={this.inherit} />
                          <Cta text="GUARDAR CAMBIOS" centered className="medium" click={this.save} />
                        </td>
                      </tr> : <tr><td></td></tr>}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>}
      </div>
  }

}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(StrategyPump);


// WEBPACK FOOTER //
// ./src/containers/analisis/editablestrategypump.js